// extracted by mini-css-extract-plugin
module.exports = {"input":"input_text-module__input--28_Q-","label":"input_text-module__label--RXqvz"};